<p-dialog header="Header" [(visible)]="visible" [modal]="true" [style]="{ width: '90%' }" [draggable]="false" [resizable]="false" (onHide)="onDialogClose()">
  <ng-template pTemplate="header">
    <span class="text-xl  font-bold"><i class="pi pi-check"></i> Producto añadido correctamente a su carrito de compras.</span>
  </ng-template>
  <div class="grid">
    <div class="col-12 sm:col-12 md:col-6 lg:col-6 xl:col-6">
      <div class="grid">
        <div class="col-12 sm:col-12 md:col-6 lg:col-6 xl:col-6">
          <img [src]="item.product.image" alt="" style="max-width: 100%; max-height: 15rem;">
        </div>
        <div class="col-12 sm:col-12 md:col-6 lg:col-6 xl:col-6">
          <p>{{ item.product.productName }}</p>
          <p>Precio: {{ showPrice() | currency }} COP</p>
          <p>Cantidad: {{ item.cant }}</p>
          <p>Total: {{ (item.cant * showPrice()) | currency }}</p>
        </div>
      </div>
    </div>
    <div class="col-12 sm:col-12 md:col-6 lg:col-6 xl:col-6">
      <div class="grid">
        <div class="col-12 sm:col-12 md:col-12 lg:col-12 xl:col-12">
          <p>Hay {{numItem}} artículo(s) en su carrito.</p>
          <p>Total de productos: {{totPriceWishList | currency}} </p>
          <p *ngIf="address != ''"><b>Dirección de entrega:</b> {{address}} </p>
        </div>
        <div class="col-12 sm:col-12 md:col-6 lg:col-6 xl:col-6">
          <div class="col-12">
            <div class="p-fluid">
              <div class="p-field">
                <custom-button
                  label="SEGUIR COMPRANDO"
                  [routerLink]="['/product-catalog']"
                  (click)="onDialogClose()"
                ></custom-button>
              </div>
              <div class="p-field">
                <custom-button
                  label="CARRITO"
                  [routerLink]="['/shopping-car']"
                ></custom-button>
              </div>
              <div class="p-field"  *ngIf="userLocalStorage">
                <custom-button
                  label="REALIZAR PEDIDO"
                  (click)="confirmDirection()"
                ></custom-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
